import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, IconButton, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import SectionCard from "./SectionCard";
import CurrencySelect from "./CurrencySelect";
import { useCurrencies } from "./useCurrencies";

const SubAgentDiscount: React.FC = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<any>();
  const { currencies, loading, getDefaultId } = useCurrencies();
  const rows = values.discounts ?? [];

  // Ensure at least one row and default currency once currencies load
  useEffect(() => {
    if (!currencies) return;
    if (!Array.isArray(values.discounts) || values.discounts.length === 0) {
      setFieldValue("discounts", [
        {
          maxDiscount: 0,
          automaticDiscount: 0,
          minimumTicketPrice: 0,
          currencyId: getDefaultId(),
        },
      ]);
    } else {
      const patched = values.discounts.map((r: any) => ({
        ...r,
        currencyId: r?.currencyId ?? getDefaultId(),
      }));
      setFieldValue("discounts", patched);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencies]);

  const addRow = () =>
    setFieldValue("discounts", [
      ...(values.discounts ?? []),
      {
        maxDiscount: 0,
        automaticDiscount: 0,
        minimumTicketPrice: 0,
        currencyId: getDefaultId(),
      },
    ]);

  const removeRow = (idx: number) =>
    setFieldValue(
      "discounts",
      (values.discounts ?? []).filter((_: any, i: number) => i !== idx)
    );

  return (
    <SectionCard title="Discounts">
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            name="discountType"
            label="Discount Type"
            value={values.discountType || "ALLOW_DISCOUNT"}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            type="number"
            fullWidth
            name="allowedDiscount"
            label="Allowed Discount"
            value={values.allowedDiscount ?? 0}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      {(rows.length ? rows : [{}]).map((_: any, idx: number) => (
        <Grid container spacing={2} key={idx} style={{ marginTop: 8 }} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`discounts[${idx}].maxDiscount`}
              label="Max Discount"
              value={rows[idx]?.maxDiscount ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`discounts[${idx}].automaticDiscount`}
              label="Automatic Discount"
              value={rows[idx]?.automaticDiscount ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`discounts[${idx}].minimumTicketPrice`}
              label="Min Ticket Price"
              value={rows[idx]?.minimumTicketPrice ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <CurrencySelect
              name={`discounts[${idx}].currencyId`}
              label="Currency"
              value={rows[idx]?.currencyId}
              onChange={handleChange}
              currencies={currencies}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <Tooltip title="Remove">
              <span>
                <IconButton
                  onClick={() => removeRow(idx)}
                  disabled={(values.discounts ?? []).length <= 1}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      ))}

     
    </SectionCard>
  );
};

export default SubAgentDiscount;
